<template>
  <main class="content">
      <div class="row">
          <h1>
              Block new timeslots
          </h1>
      </div>
      <form v-on:submit.prevent="addBlocked" class="form">
          <Message v-if="errorMessage" :message-content="errorMessage" message-status="error"></Message>

          <fieldset class="form--item">
              <label class="label" for="">
                  Wall:
              </label>
              <div class="input_text" id="wall_id">
              <v-select v-model="wallId" required :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  From this day:
              </label>
              <div class="input_text" id="starttime_date">
                <el-date-picker
                    required
                    v-model="starttime.date"
                    type="date"
                    placeholder="Click to select a start day">
                </el-date-picker>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  From this timeslot:
              </label>
              <div class="input_text" id="starttime_time">
                <el-time-select
                    v-model="starttime.time"
                    :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '23:45'
                    }"
                    placeholder="Click to select a start timeslot">
                </el-time-select>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  To this day:
              </label>
              <div class="input_text" id="endtime_date">
                  <el-date-picker
                      required
                      v-model="endtime.date"
                      type="date"
                      placeholder="Click to select an end day:">
                  </el-date-picker>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  To this timeslot:
              </label>
              <div class="input_text" id="endtime_time">
                  <el-time-select
                      v-model="endtime.time"
                      :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '23:45'
                      }"
                      placeholder="Click to select a end timeslot">
                  </el-time-select>
              </div>
          </fieldset>
          <fieldset class="form--item">
              <label class="label" for="">
                  Reason:
              </label>
              <div class="input_text" id="reason">
                  <input name="" v-model="blocked.reason" placeholder="Add a reason why you block these timeslots" type="text"/>
              </div>
          </fieldset>
          <div class="row">
              <button class="btn btn_blue" type="submit">
                  Block timeslots
              </button>
          </div>
      </form>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import vSelect from "vue-select"
import Message from '../Message.vue'
import Loading from '../Loading.vue'

import * as ValidateForm from '../../mixins/validate-form.mixin';
import * as CreateResource from '../../mixins/createResource.mixin';

export default {
  name: 'AddBlocked',
  components: {vSelect, Message, Loading},
  mixins: [ValidateForm, CreateResource],
  data () {
    return {
      required_fields: [
        {'attribute': 'wallId', 'message': 'WallId is missing', 'id': 'wall_id'},
        {'attribute': 'starttime.date', 'message': 'From day is missing', 'id': 'starttime_date'},
        {'attribute': 'starttime.time', 'message': 'From time is missing', 'id': 'starttime_time'},
        {'attribute': 'endtime.date'  , 'message': 'To day is missing', 'id': 'endtime_date'},
        {'attribute': 'endtime.time'  , 'message': 'To time is missing', 'id': 'endtime_time'},
        {'attribute': 'blocked.reason', 'message': 'Reason is missing', 'id': 'reason'}
      ],
      resource: 'schedule/blocked',
      parentResource: 'Blocked',
      blocked: {

      },
      walls: [],
      wallId: '',
      starttime: {
        date: '',
        time: ''
      },
      endtime: {
        date: '',
        time: ''
      }
    }
  },
  created(){
    var self = this;
    HttpService.index('walls', {}, function(response, error){
      self.walls = response.result.data;
      self.walls = self.walls.map(item => {
        return {value: item.id, label: item.name}
      });
    });
  },
  methods: {
    addBlocked(){
      if(this.validate()){
        this.blocked.wallId = this.wallId.value || this.blocked.wallId;

        this.blocked.from = this.getTimeslot(this.starttime);
        this.blocked.to = this.getTimeslot(this.endtime);
      }

      this.createResource(this.blocked);
    },
    getTimeslot(datetime){
      let time = datetime.time.split(":");
      let slot = time[0] * 4 + time[1] / 15;

      let datestring = datetime.date;
      datestring = datestring.getFullYear() + '' + ("00" + (datestring.getMonth() + 1)).slice(-2) + ("00" + datestring.getDate()).slice(-2);

      return datestring + ("00" + slot).slice(-2);
    }

  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// AddBlocked.vue?7209a4e8